module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.fieldLabel) ? _c('label', [_vm._v(_vm._s(_vm.fieldLabel)), (_vm.required) ? _c('span', [_vm._v(" *"), _c('div', {
    staticClass: "helptip-wrapper"
  }, [(_vm.helptipBody) ? _c('span', {
    staticClass: "helptip-icon",
    on: {
      "click": function($event) {
        _vm.toggleHelp()
      }
    }
  }, [_c('i', {
    class: [_vm.showHelp ? _vm.hideIcon : _vm.showIcon]
  })]) : _vm._e(), (_vm.helptipBody && _vm.showHelp || _vm.helptipBody && _vm.error) ? _c('ed-input-tooltip', {
    class: {
      "error-message": _vm.error
    },
    attrs: {
      "helptipHeader": _vm.helptipHeader,
      "errorTip": _vm.error,
      "helptipBody": _vm.helptipBody
    }
  }) : _vm._e()], 1)]) : _vm._e()]) : _vm._e(), _c('label', {
    class: _vm.classObject
  }, [(_vm.shouldShowLabel) ? _c('span', {
    staticClass: "vue-switcher__label"
  }, [(_vm.label) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e()]) : _vm._e(), _c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.trigger
    }
  }), _c('div', {
    staticClass: "dawn-switch-switch"
  }, [(!_vm.label && _vm.value) ? _c('span', {
    staticClass: "switch-text",
    domProps: {
      "textContent": _vm._s(_vm.textEnabled)
    }
  }) : _vm._e(), (!_vm.label && !_vm.value) ? _c('span', {
    staticClass: "switch-text",
    domProps: {
      "textContent": _vm._s(_vm.textDisabled)
    }
  }) : _vm._e()])]), (_vm.value) ? _c('span', [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dca3dae","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edSwitch/index.vue
// module id = GUo4
// module chunks = 13 14